import { Action, createReducer, on } from '@ngrx/store';
import { ClientsActions } from './clients.actions';
import { clientsInitialState, ClientsState } from './clients.state';

const _clientsReducer = createReducer(
  clientsInitialState(),

  /**
   * Reducers For Get All Clients
   */

  on(ClientsActions.getAllClients, (state) => {
    return {
      ...state,
      allClients: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.getAllClientsSuccess, (state, { clients }) => {
    return {
      ...state,
      allClients: {
        loading: false,
        data: clients.data,
      },
    };
  }),
  on(ClientsActions.getAllClientsFailure, (state, { failure }) => {
    return {
      ...state,
      allClients: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Create Client
   */
  on(ClientsActions.createClient, (state) => {
    return {
      ...state,
      createClient: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.createClientSuccess, (state, { response }) => {
    return {
      ...state,
      createClient: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.createClientFailure, (state, { failure }) => {
    return {
      ...state,
      createClient: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Remove Client
   */
  on(ClientsActions.removeClient, (state) => {
    return {
      ...state,
      removeClient: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.removeClientSuccess, (state, { response }) => {
    return {
      ...state,
      removeClient: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.removeClientFailure, (state, { failure }) => {
    return {
      ...state,
      removeClient: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Client By Id
   */
  on(ClientsActions.clientById, (state) => {
    return {
      ...state,
      clientById: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.clientByIdSuccess, (state, { response }) => {
    return {
      ...state,
      clientById: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.clientByIdFailure, (state, { failure }) => {
    return {
      ...state,
      clientById: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Remove Member
   */
  on(ClientsActions.removeMember, (state) => {
    return {
      ...state,
      removeMember: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.removeMemberSuccess, (state, { response }) => {
    return {
      ...state,
      removeMember: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.removeMemberFailure, (state, { failure }) => {
    return {
      ...state,
      removeMember: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Member By Id
   */
  on(ClientsActions.memberById, (state) => {
    return {
      ...state,
      memberById: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.memberByIdSuccess, (state, { response }) => {
    return {
      ...state,
      memberById: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.memberByIdFailure, (state, { failure }) => {
    return {
      ...state,
      memberById: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Update Member
   */
  on(ClientsActions.updateMember, (state) => {
    return {
      ...state,
      updateMember: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.updateMemberSuccess, (state, { response }) => {
    return {
      ...state,
      updateMember: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.updateMemberFailure, (state, { failure }) => {
    return {
      ...state,
      updateMember: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Add Member
   */
  on(ClientsActions.addMember, (state) => {
    return {
      ...state,
      addMember: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.addMemberSuccess, (state, { response }) => {
    return {
      ...state,
      addMember: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.addMemberFailure, (state, { failure }) => {
    return {
      ...state,
      addMember: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Update Client
   */
  on(ClientsActions.updateClient, (state) => {
    return {
      ...state,
      updateClient: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.updateClientSuccess, (state, { response }) => {
    return {
      ...state,
      updateClient: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.updateClientFailure, (state, { failure }) => {
    return {
      ...state,
      updateClient: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Pending Request By Client
   */
  on(ClientsActions.getPendingRequestsByMember, (state) => {
    return {
      ...state,
      pendingRequestByMember: {
        loading: true,
      },
    };
  }),
  on(
    ClientsActions.getPendingRequestsByMemberSuccess,
    (state, { response }) => {
      return {
        ...state,
        pendingRequestByMember: {
          loading: false,
          data: response.data,
        },
      };
    }
  ),
  on(ClientsActions.getPendingRequestsByMemberFailure, (state, { failure }) => {
    return {
      ...state,
      pendingRequestByMember: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Remove a Member and Assign
   */
  on(ClientsActions.removeAndAssign, (state) => {
    return {
      ...state,
      removeAndAssign: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.removeAndAssignSuccess, (state, { response }) => {
    return {
      ...state,
      removeAndAssign: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.removeAndAssignFailure, (state, { failure }) => {
    return {
      ...state,
      removeAndAssign: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Remove a Member and Assign
   */
  on(ClientsActions.addMultipleMembers, (state) => {
    return {
      ...state,
      addMultipleMembers: {
        loading: true,
      },
    };
  }),
  on(ClientsActions.addMultipleMembersSuccess, (state, { response }) => {
    return {
      ...state,
      addMultipleMembers: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ClientsActions.addMultipleMembersFailure, (state, { failure }) => {
    return {
      ...state,
      addMultipleMembers: {
        loading: false,
        failure: failure,
      },
    };
  })
);

export function clientsReducer(
  state: ClientsState | undefined,
  action: Action
) {
  return _clientsReducer(state, action);
}
